import axios from 'axios';
import cookie from '../../cookieHelper/cookie';

export default async function getCompanyPurchases(centralCompanyId, page = 0, size = 10, signal) {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/purchases`, {
        params: { centralCompanyId, page, size },
        signal,
        headers: { Authorization: `Bearer ${cookie.getCookie(process.env.REACT_APP_COOKIE_NAME)}` },
    });
    const result = response.data;
    if (String(result?.status?.code) !== '10200' || !Array.isArray(result?.data?.purchases)) {
        const error = new Error(result?.status?.message || 'Unable to load purchases.');
        error.response = response;
        throw error;
    }
    return {
        ...result.data,
        purchases: result.data.purchases.map(purchase => ({
            ...purchase,
            activeStoryCount: purchase.activeStoryCount ?? purchase.activeStories?.length ?? 0,
        })),
    };
}

export async function getAllCompanyPurchases(centralCompanyId, signal) {
    const size = 100;
    const first = await getCompanyPurchases(centralCompanyId, 0, size, signal);
    const purchases = [ ...first.purchases ];
    for (let page = 1; page < Math.ceil(first.total / size); page += 1) {
        const result = await getCompanyPurchases(centralCompanyId, page, size, signal);
        purchases.push(...result.purchases);
    }
    return { purchases, total: purchases.length };
}
